import { useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import PageLoader from "../../../../../../../components/PageLoader";
import { selectListItems } from "../../../../../../../redux/library/selector";
import Table from "../../../../../../../common/components/table-manager/v1.1/table";
import _ from "lodash";
import { marketingEmailplans } from "../../../../../../../redux/marketing-email-plans/action";
import { selectMarketingEmailPlansListItems } from "../../../../../../../redux/marketing-email-plans/selector";

const ListEmailPlans = ({
  choosenEmailTemplate,
  selectedPlanId,
  setSelectedPlanId,

}: any) => {
  const dispatch = useAppDispatch();
  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectMarketingEmailPlansListItems);
  const libraryData = useSelector(selectListItems);
  const [columnDefs, setColumnDefs] = useState<any>([]);

  useEffect(() => {
    if (choosenEmailTemplate?.EmailPlanId > 0) {
      setSelectedPlanId(choosenEmailTemplate?.EmailPlanId);
    }
  }, [choosenEmailTemplate]);

  useEffect(() => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer: (params: any) => parseInt(params.node.id, 10) + 1,
      },

      { field: 'Name', headerName: 'Plan' },
      {
        field: 'FrequencyId',
        headerName: 'Frequency',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.CampaignFrequency },
      },
      { field: 'StartDate', headerName: 'Start Date', isDateValueFormat: true },
      { field: 'EndDate', headerName: 'End Date', isDateValueFormat: true },
       {
        field: 'CampaignTypeId',
        headerName: 'Campaign Type',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.CampaignType },
      },
    ]);
  }, [selectedPlanId, libraryData]);


  const handleSelect = useCallback((planIdArr: any) => {
    const selectedPlan = itemsData?.result?.items?.find(
      (item: any) => item.Id === planIdArr[0]?.Id
    );


    setSelectedPlanId(selectedPlan);


  }, [itemsData]);

  const fetchPlan = () => {
    dispatch(
      marketingEmailplans.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/email-plans/list`,
        entity: 'plans',
        jsonData: {
          PageNumber: pageData,
          PageSize: pageSize,
        },
      })
    );
  };

  useEffect(() => {
    fetchPlan();
  }, [pageData, pageSize]);

  return (
    <>
      {itemsData?.isLoading ? (
        <PageLoader />
      ) : (
        <Table
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          headingName="Plans"
          onSelect={handleSelect}
          checkboxConfig={{
            allowMultiSelect: false,
            defaultSelectedIds: selectedPlanId ? selectedPlanId : '',
            isDisabled: false,
            keyColumn: 'Id',

          }}
        />
      )}
    </>
  );
};

export default ListEmailPlans;
